<script setup>
import { computed } from 'vue';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils.js';

const props = defineProps({
    variant: { type: String, default: 'default' },
    size: { type: String, default: 'default' },
    as: { type: String, default: 'button' },
});

const buttonVariants = cva(
    'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] disabled:pointer-events-none disabled:opacity-50',
    {
        variants: {
            variant: {
                default: 'bg-[var(--primary)] text-[var(--primary-foreground)] hover:opacity-90',
                outline: 'border border-[var(--border)] bg-transparent text-[var(--foreground)] hover:bg-[var(--accent)]',
                ghost: 'bg-transparent text-[var(--foreground)] hover:bg-[var(--accent)]',
                destructive: 'bg-[var(--destructive)] text-white hover:opacity-90',
            },
            size: {
                default: 'h-10 px-4 py-2',
                sm: 'h-8 px-3 text-xs',
                lg: 'h-12 px-6 text-base',
                icon: 'h-10 w-10 p-0',
            },
        },
        defaultVariants: { variant: 'default', size: 'default' },
    }
);

const classes = computed(() => cn(buttonVariants({ variant: props.variant, size: props.size })));
</script>

<template>
    <component :is="as" :class="classes">
        <slot />
    </component>
</template>
